var $ = require('jquery');
window.jQuery = $;
window.$ = $;

require("console-polyfill");
require("jquery-match-height");
var dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin

window.dayjs = dayjs;
window.utc = utc;
window.timezone = timezone;
require("jquery.mmenu");
require("lightbox2");
require("lity");
require("slick-carousel");

// Required for isotope to check if images have finished loading to run https://imagesloaded.desandro.com/
//require("imagesloaded/imagesloaded.pkgd.min");


// WEBPACK FOOTER //
// ./src/js/vendor.js